// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetPatientRequestModel {
    static getAttributeTypeMap() {
        return GetPatientRequestModel.attributeTypeMap;
    }
}
GetPatientRequestModel.discriminator = undefined;
GetPatientRequestModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    }
];
//# sourceMappingURL=getPatientRequestModel.js.map